import actions from './actions';

export default {
  getFoodmakerBySlug: actions.getFoodmakerBySlug,
  getFoodmakerById: actions.getFoodmakerById,
  trackFoodmakerView: actions.trackFoodmakerView,
};
